import { Checkbox } from 'antd';

export default Checkbox;